const isAbsoluteURI = (uri) => /^https?:\/\//.test(uri)

export function getStaticPath(value) {
  if (isAbsoluteURI(value)) return value
  return `${CLIENT_STATIC_PATH === '/' ? '' : CLIENT_STATIC_PATH}${value}`
}

export function checkGeoCategoryLocales(geoCategory) {
  const badLocales = []
  Object.keys(geoCategory.locales).forEach(locale => {
    if (!geoCategory.locales[locale].name) {
      badLocales.push(locale)
    }
  })
  return badLocales
}

export function checkGeoObjectLocales(geoObject) {
  const badLocales = []
  Object.keys(geoObject.locales).forEach(locale => {
    if (!geoObject.locales[locale].name || !geoObject.locales[locale].description) {
      badLocales.push(locale)
    }
  })
  return badLocales
}

export const buildURLQuery = obj =>
  Object.entries(obj)
    .map(pair => pair.map(encodeURIComponent).join('='))
    .join('&')
